





























































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { YKDRightDrawer } from 'gum-ui'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'
import Topic from '@/model/exam/topic'
const TopicPart = namespace('app-exam/topicPart')
import TopicGroupSelectedRecord from '@/model/exam/topicGroupSelectedRecord'
import { queryPagingTopic, deleteTopic, queryAllTopic } from '@/api/exam/topic'

import { getTopicPart } from '@/api/exam/topicGroup'
import FixedCreateTopicCenterDialog from '@/apps/exam/views/topicgroup/components/FixedCreateTopicCenterDialog.vue'
import FixedCreateTopicCenterDialog2 from '@/apps/exam/views/topicgroup/components/FixedCreateTopicCenterDialog2.vue'

import { delHtmlTag } from '@/apps/exam/util/htmlUtil'
interface Paging {
  pageSize?: number
  current?: number
  total?: number
}
@Component({
  components: {
    YKDRightDrawer,
    FixedCreateTopicCenterDialog,
    FixedCreateTopicCenterDialog2
  }
})
export default class FixedCreaTopic extends Vue {
  @Prop() private visible?: boolean
  @Prop() private topicPart?: TopicPart
  @Prop() private topicGroup?: TopicGroup
  @TopicPart.Action('editTopicPart') editTopicPart!: Function

  private centerDrawer: boolean = false
  private columns = [
    {
      title: '题目',
      dataIndex: 'name',
      width: '300px'
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]
  private keyword?: string = ''
  private data: any[] = []
  private plainOptions = []
  private defaultCheckedList = []
  private selectedRowKeys: any[] = []
  private indeterminate: boolean = true
  private checkAll: boolean = false
  private isEmpty: boolean = true
  private accountDepartmentMap: any = {}
  private accounts: Account[] = []
  private topics: Topic[] = []
  @Watch('visible')
  async initData() {
    this.topics = []
    await this.initializeData()
  }

  async initializeData() {
    //判断是否有题目

    if (this.topicPart!.records && this.topicPart!.records.length > 0) {
      let topicIds: string[] = []
      let topicBankIds: string[] = []
      //取出所有的topicId
      let isEmptyData: boolean = true
      this.topicPart!.records.forEach((selectRecord, index) => {
        if (selectRecord.topicIds && selectRecord.topicIds.length > 0) {
          selectRecord.topicIds.forEach((topicId, topicIndex) => {
            topicIds.push(topicId)
            isEmptyData = false
          })
        }
      })
      if (isEmptyData) {
        this.data = []
        this.isEmpty = true
        return
      }
      if (topicIds && topicIds.length > 0) {
        const data = await queryAllTopic({
          topicIds: topicIds
        })
        if (data && data.length > 0) {
          data.forEach((tc, tcIndex) => {
            this.topics.push(tc)
          })
        }
      }
      this.data = []
      for (let i = 0; i < this.topics.length; i++) {
        this.data.push({
          key: this.topics![i].id,
          name: delHtmlTag(this.topics[i].name!)
        })
      }
      this.isEmpty = false
    } else {
      this.data = []
      this.isEmpty = true
      return
    }
  }
  async mounted() {
    //await this.initializeData()
  }
  closeCenter() {
    this.centerDrawer = false
  }
  openCenter() {
    this.centerDrawer = true
  }
  async confirmTopic(chosenTopics: Topic[]) {
    if (chosenTopics && chosenTopics.length > 0) {
      //添加选择的题库
      //判断是否有选择的题库

      let topicIds: string[] = []
      let topicBankId: string[] = []
      chosenTopics.forEach((item, index) => {
        if (item.selectTopicBankId) {
          topicBankId.push(item.selectTopicBankId)
        } else if (item.id) {
          topicIds.push(item.id!)
        }
      })
      if (topicBankId && topicBankId.length > 0) {
        let topicdata = await queryAllTopic({
          topicBankId: topicBankId
        })
        if (topicdata && topicdata.length > 0) {
          topicdata.forEach((t, tIndex) => {
            topicIds.push(t.id!)
          })
        }
      }
      if (topicIds && topicIds.length > 0) {
        let selectedRecord: TopicGroupSelectedRecord = {}
        selectedRecord.topicIds = topicIds
        selectedRecord.topicGroupId = this.topicPart!.topicGroupId!
        if (!this.topicPart!.records) {
          this.topicPart!.records = []
        }
        this.topicPart!.records!.push(selectedRecord)
      }
      this.topics = []
      await this.editTopicPart(this.topicPart)
    }
    this.topicPart = await getTopicPart(this.topicPart!.id!)
    await this.initializeData()
    this.centerDrawer = false
  }
  addTopic() {
    //判断当前题目是否已满
    if (this.data.length >= this.topicPart!.topicNumber!) {
      this.$message.error('出题数量已满')
    } else {
      this.centerDrawer = true
    }
  }
  //删除
  async deleteTopic(text: any, record: any) {
    //添加选择的题库
    let selectedRecords: TopicGroupSelectedRecord[] = []
    if (this.topicPart!.records && this.topicPart!.records.length > 0) {
      this.topicPart!.records.forEach((item, index) => {
        if (item.topicIds && item.topicIds.length > 0) {
          let selectedRecord: TopicGroupSelectedRecord = {}
          let topicIdList: string[] = []
          item.topicIds.forEach((topicItem, topicINdex) => {
            if (record.key != topicItem) {
              topicIdList.push(topicItem)
            }
          })
          selectedRecord.topicIds = topicIdList
          selectedRecord.topicGroupId = this.topicPart!.topicGroupId

          if (item.topicBankId) {
            selectedRecord.topicBankId = item.topicBankId
          }
          selectedRecords.push(selectedRecord)
        }
      })
    }
    this.topicPart!.records = selectedRecords
    await this.editTopicPart(this.topicPart)

    //刷新数据
    this.topics.forEach((item, index) => {
      if (record.key === item.id) {
        this.topics.splice(index, 1)
      }
    })
    if (this.topics!.length === 0) {
      this.isEmpty = true
      this.data = []
      return
    }
    this.data = []
    for (let i = 0; i < this.topics!.length; i++) {
      this.data.push({
        key: this.topics![i].id,
        name: delHtmlTag(this.topics[i].name!)
      })
    }
  }

  //批量删除
  async batchDeleteTopic() {
    console.log('pppppppppppp')
    if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
      let selectedRecords: TopicGroupSelectedRecord[] = []
      if (this.topicPart!.records && this.topicPart!.records.length > 0) {
        this.topicPart!.records.forEach((item, index) => {
          if (item.topicIds && item.topicIds.length > 0) {
            let selectedRecord: TopicGroupSelectedRecord = {}
            let topicIdList: string[] = []
            item.topicIds.forEach((topicItem, topicINdex) => {
              if (this.selectedRowKeys.indexOf(topicItem) === -1) {
                topicIdList.push(topicItem)
              }
            })
            selectedRecord.topicIds = topicIdList
            selectedRecord.topicGroupId = this.topicPart!.topicGroupId

            if (item.topicBankId) {
              selectedRecord.topicBankId = item.topicBankId
            }
            selectedRecords.push(selectedRecord)
          }
        })
      }
      this.topicPart!.records = selectedRecords
      console.log(this.topicPart, 'llllllllll')
      await this.editTopicPart(this.topicPart)
      this.topics = []
      this.topicPart = await getTopicPart(this.topicPart!.id!)
      await this.initializeData()
    } else {
      this.$message.error('请勾选题目')
    }
  }
  onSelectChange(selectedRowKeys: any) {
    this.selectedRowKeys = selectedRowKeys
  }
  onChange(checkedList: any) {
    this.indeterminate =
      !!checkedList.length && checkedList.length < this.plainOptions.length
    this.checkAll = checkedList.length === this.plainOptions.length
  }
  onCheckAllChange(e: any) {}
  close() {
    this.$emit('closeFixedCreaTopic')
  }
  async confirm() {
    this.$emit('closeFixedCreaTopic')
  }
}
